import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "../lib/api";

export default function BlogPost() {
  const { slug } = useParams();
  const [p, setP] = useState(null);
  useEffect(() => { api.get(`/blog/${slug}`).then((r) => setP(r.data)); }, [slug]);
  if (!p) return <div className="pt-32 text-center">Loading…</div>;

  return (
    <div data-testid="blog-post" className="pt-24">
      <article className="container mx-auto px-4 pt-12 pb-24 max-w-3xl">
        <Link to="/blog" className="text-sm text-zinc-500 hover:text-[#FF007F]">← All articles</Link>
        <div className="text-[10px] font-mono uppercase tracking-widest text-[#FF007F] mt-6 mb-3">{p.category}</div>
        <h1 className="font-display font-black text-4xl sm:text-5xl tracking-tighter mb-4 leading-tight">{p.title}</h1>
        <p className="text-lg text-[#52525B] mb-6">{p.excerpt}</p>
        <div className="text-sm text-zinc-500 mb-8">By {p.author}</div>
        <img src={p.cover_image} alt={p.title} className="w-full aspect-[16/9] object-cover rounded-2xl mb-8" />
        <div className="prose prose-lg max-w-none whitespace-pre-wrap">{p.content}</div>
      </article>
    </div>
  );
}
